export const FETCHING_RENTABLE_CIRCLES = "FETCHING.CIRCLES.RENTABLE";
export const FETCHED_RENTABLE_CIRCLES = "FETCHED.CIRCLES.RENTABLE";
export const ERROR_FETCHING_RENTABLE_CIRCLES = "ERROR.FETCHING_RENTABLE_CIRCLES";
